module.exports = __webpack_public_path__ + "static/media/01.7cab8967.png";